import classNames from "classnames";
import { If } from "react-conditional-components-renderer";
import AscButton from "../AscButton/AscButton";

import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";
import { CheckMarkIcon } from "../AscIcons";
import styles from "./AscProfilePreview.module.scss";
import { AuthUserRole, IUserPermisson, appConfig } from "@ascendnow/shared";

export interface AscProfilePreviewProps {
  className?: string;
  image?: string;
  name: string;
  email?: string;
  status?: string;
  role?: string;
  accessPermissions?: IUserPermisson[];
  onlyInfoField?: boolean;
  onClick?: () => void;
}

export default function AscProfilePreview({
  className,
  image,
  name,
  email,
  status,
  role,
  onlyInfoField = false,
  onClick,
  accessPermissions,
}: AscProfilePreviewProps) {
  return (
    <div
      data-testid="asc-profile-preview"
      className={classNames(styles.ground, className)}
    >
      <div
        className={classNames(
          styles.topGround,
          !onlyInfoField && styles.withBorder
        )}
      >
        <div className={styles.userInfo}>
          {image ? (
            <img src={image} alt={image} className={styles.image} />
          ) : (
            <div className={styles.noImage} />
          )}

          <div className={styles.rightSection}>
            <div className={styles.nameSection}>
              <AscHeading className={styles.userName}>{name}</AscHeading>
              <div
                className={classNames(styles.status, {
                  [styles.active]: status === "active",
                  [styles.inactive]: status === "inactive",
                  [styles.invite]: status === "invite",
                })}
              >
                <If test={status === "active"}>
                  <span>Active</span>
                </If>
                <If test={status === "inactive"}>
                  <span>Inactive</span>
                </If>
                <If test={status === "invite"}>
                  <span>Invite sent</span>
                </If>
              </div>
            </div>

            <AscParagraph className={styles.email}>{email}</AscParagraph>

            <div className={styles.role}>
              <div className={styles.circle} />
              <AscParagraph className={styles.text}>{role}</AscParagraph>
            </div>
          </div>
        </div>

        {!onlyInfoField && (
          <AscButton onClick={onClick} className={styles.button}>
            Edit Profile
          </AscButton>
        )}
      </div>

      {(role === appConfig.role.SCHOOL || role === appConfig.role.TEACHER) &&
        accessPermissions &&
        Array.isArray(accessPermissions) &&
        accessPermissions.length > 0 && (
          <div className={styles.accessGround}>
            <AscHeading className={styles.header}>Access</AscHeading>

            <ul className={styles.accessGround}>
              {accessPermissions.map((item: IUserPermisson, index) => (
                <li key={index} className={classNames(styles.accessList)}>
                  <CheckMarkIcon
                    className={classNames(styles.icon, {
                      [styles.activeIcon]: item.access.includes(
                        role as AuthUserRole
                      ),
                    })}
                  />
                  <AscParagraph
                    className={classNames(styles.title, {
                      [styles.active]: item.access.includes(
                        role as AuthUserRole
                      ),
                    })}
                  >
                    {item.title}
                  </AscParagraph>
                </li>
              ))}
            </ul>
          </div>
        )}
    </div>
  );
}
